

import React, { useState, useMemo, useEffect } from "react";
import {
  Row,
  Col,
  Button,
  Card,
  Tag,
  Typography,
  Input,
  DatePicker,
  InputNumber,
  Radio,
  Select,
  message,
  Modal,
  Tooltip,
  Steps,
  Slider,
} from "antd";
import { get_ListeRegion, carburantConfig } from "../../api/region";
import { create_devis, create_devis_bennes } from "../../api/devis";
import { get_ListeClients } from "../../api/clients";
import "moment/locale/fr";
import moment from "moment";
import Notification from "../../composants/Notification";
import { getPermissionsFromToken, hasPermission } from "../../utils/utils";
import { TruckOutlined, InboxOutlined } from "@ant-design/icons";
const { TextArea } = Input;
const { Option } = Select;
const { Title, Text } = Typography


const Dotations = () => {
  const [listeRegion, setlisteRegion] = useState([]);
  const [listeClient, setListeClients] = useState([]);
  const fraisTypes = [
    { value: "perdiem_chauffeur", label: "Per diem Chauffeur" },
    { value: "perdiem_aide", label: "Per diem Aide" },
    { value: "credit", label: "Crédit" },
    { value: "parking", label: "Parking" },
    { value: "contravention", label: "Contravention" },
    { value: "divers", label: "Divers" },
    { value: "chargement", label: "Chargement" },
    { value: "dechargement", label: "Déchargement" },
    { value: "arrimage", label: "Arrimage" },
  ];
  const [currentStep, setCurrentStep] = useState(0);
  const [currentTrajet, setcurrentTrajet] = useState({
    frais: [],
    type_devis: null,
    id: null,
    client_id: null,
    date_depart: null,
    date_arrive: null,
    region_depart: null,
    region_arrive: null,
    description: null,
    carburant: 0,
    carburant_aller: 0,
    carburant_retour: 0,
    distance: 0,
    camion_id: null,
    status_aller: 1,
    status_retour: 0,
    coefficient_charge: null,
    coefficient_vide: null,
    prix_gasoil: null,
    total_gasoil: 0,
    cotation: 0,
    cotation_type: "poids",
    total_brute: 0,
    total_benefice: 0,
    poids: 0,
    chargement: 0,
    chargement_multi: 1,
    dechargement: 0,
    dechargement_multi: 1,
    arrimage: 0,
    arrimage_multi: 1,
    // information rajoutés
    perdiem_chauffeur: 20000,
    multi_perdiem_chauffeur: 0,

    perdiem_aide: 20000,
    multi_perdiem_aide: 0,

    credit: 1000,
    mult_credit: 1,
    parking: 5000,
    mult_parking: 1,
    contravention: 5000,
    mult_contravention: 1,
    divers: 0,
    mult_divers: 1,
    total_frais: 0,
    jours_trajet: 0,

    tva: 0,
    acompte: 0,
    paiement: "cheque",
    coefficient_distance: 1,
    distance_reference: 365,
    limite_paiement: 5,
  });
  const prixReelKg = parseFloat(
    ((currentTrajet.cotation || 0) * (currentTrajet.coefficient_distance || 1)).toFixed(2)
  );
  const totalHT = currentTrajet.total_brute || 0;
  const montantTVA = parseFloat((totalHT * (currentTrajet.tva || 0) / 100).toFixed(2));
  const totalTTC = parseFloat((totalHT + montantTVA).toFixed(2));

  // Nombre de jours calculé à partir de la date de départ et de la date d'arrivée
  // (jours calendaires inclusifs : du 10 au 12 => 3 jours, même jour => 1 jour)
  const nombreJours = useMemo(() => {
    const { date_depart, date_arrive } = currentTrajet;
    if (!date_depart || !date_arrive) return 0;
    const debut = moment(date_depart).startOf("day");
    const fin = moment(date_arrive).startOf("day");
    const diff = fin.diff(debut, "days");
    return diff < 0 ? 0 : diff + 1;
  }, [currentTrajet.date_depart, currentTrajet.date_arrive]);

  const nombreJourParking = nombreJours;
  const [modalLimitePaiement, setModalLimitePaiement] = useState(false);
  const [isloading, setisloading] = useState(false)
  const volumetries = [
    { label: "10 m³", value: "10" },
    { label: "11 m³", value: "11" },
    { label: "12 m³", value: "12" },
    { label: "13 m³", value: "13" },
    { label: "14 m³", value: "14" },
    { label: "15 m³", value: "15" },
    { label: "16 m³", value: "16" },
    { label: "17 m³", value: "17" },
    { label: "18 m³", value: "18" },
    { label: "19 m³", value: "19" },
    { label: "20 m³", value: "20" },
    { label: "21 m³", value: "21" },
    { label: "22 m³", value: "22" },
    { label: "23 m³", value: "23" },
    { label: "24 m³", value: "24" },
    { label: "25 m³", value: "25" },
    { label: "26 m³", value: "26" },
    { label: "27 m³", value: "27" },
    { label: "28 m³", value: "28" },
    { label: "29 m³", value: "29" },
    { label: "30 m³", value: "30" },
    { label: "31 m³", value: "31" },
    { label: "32 m³", value: "32" },
    { label: "33 m³", value: "33" },
    { label: "34 m³", value: "34" },
    { label: "35 m³", value: "35" },
    { label: "36 m³", value: "36" },
  ];
  const locationTypes = [
    { label: "Propre", value: "propre" },
    { label: "Location", value: "location" },
  ];
  const [currentBennes, setcurrentBennes] = useState([
    { description: "Location benne", date_location: moment(), volumetrie: "20", type_location: "propre", quantite: null, prix_unitaire: null, total: 0 }
  ])

  // total_frais est recalculé par le useEffect ci-dessous : on avance simplement d'étape
  const next = () => {
    setCurrentStep(currentStep + 1);
  };
  const prev = () => setCurrentStep(currentStep - 1);

  const [showToast, setshowToast] = useState(false)
  const [notif, setnotif] = useState({
    "message": null,
    "info": null
  })

  useEffect(() => {
    fetchListeRegion();
    fetchListeClients();
  }, []);

  // Quand les dates changent, on pré-remplit les multiplicateurs liés au nombre de jours
  // (ils restent modifiables manuellement ensuite)
  useEffect(() => {
    if (nombreJours > 0) {
      setcurrentTrajet((prev) => ({
        ...prev,
        jours_trajet: nombreJours,
        multi_perdiem_chauffeur: nombreJours,
        multi_perdiem_aide: nombreJours,
        mult_parking: nombreJourParking,
      }));
    } else {
      setcurrentTrajet((prev) => ({ ...prev, jours_trajet: 0 }));
    }
  }, [nombreJours]);

  useEffect(() => {
    // On adapte les coefficients selon le statut
    const coef_aller =
      currentTrajet.status_aller === 1
        ? currentTrajet.coefficient_charge
        : currentTrajet.coefficient_vide;

    const coef_retour =
      currentTrajet.status_retour === 1
        ? currentTrajet.coefficient_charge
        : currentTrajet.coefficient_vide;

    const carburant_aller = currentTrajet.distance * coef_aller;
    const carburant_retour = currentTrajet.distance * coef_retour;

    const total_carburant = carburant_aller + carburant_retour;
    const total_gasoil = total_carburant * currentTrajet.prix_gasoil;
    let total_brute = 0 //currentTrajet.cotation * currentTrajet.poids;
    let ceof_dist = 1
    if (currentTrajet.cotation_type === "poids") {
      total_brute = currentTrajet.cotation * currentTrajet.poids * currentTrajet.coefficient_distance;
      ceof_dist = currentTrajet.distance / currentTrajet.distance_reference;
    } else {
      total_brute = currentTrajet.cotation * currentTrajet.distance;
    }

    const total_frais =
      (currentTrajet.perdiem_chauffeur * currentTrajet.multi_perdiem_chauffeur) +
      (currentTrajet.perdiem_aide * currentTrajet.multi_perdiem_aide) +
      (currentTrajet.credit * currentTrajet.mult_credit) +
      (currentTrajet.parking * currentTrajet.mult_parking) +
      (currentTrajet.contravention * currentTrajet.mult_contravention) +
      (currentTrajet.divers * currentTrajet.mult_divers) +
      (currentTrajet.chargement * currentTrajet.chargement_multi) +
      (currentTrajet.dechargement * currentTrajet.dechargement_multi) +
      (currentTrajet.arrimage * currentTrajet.arrimage_multi);
    const total_benefice = total_brute - total_gasoil - total_frais;


    setcurrentTrajet((prev) => ({
      ...prev,
      carburant_aller: parseFloat(carburant_aller.toFixed(2)),
      carburant_retour: parseFloat(carburant_retour.toFixed(2)),
      carburant: parseFloat(total_carburant.toFixed(2)),
      total_gasoil: parseFloat(total_gasoil.toFixed(2)),
      total_brute: parseFloat(total_brute.toFixed(2)),
      total_benefice: parseFloat(total_benefice.toFixed(2)),
      total_frais: parseFloat(total_frais.toFixed(2)),
      coefficient_distance: parseFloat(ceof_dist.toFixed(2)),
    }));
  }, [
    currentTrajet.distance,
    currentTrajet.coefficient_charge,
    currentTrajet.coefficient_vide,
    currentTrajet.status_aller,
    currentTrajet.status_retour,
    currentTrajet.prix_gasoil,
    currentTrajet.cotation,
    currentTrajet.poids,
    // perdiem
    currentTrajet.perdiem_aide,
    currentTrajet.multi_perdiem_chauffeur,
    currentTrajet.perdiem_chauffeur,
    currentTrajet.multi_perdiem_aide,

    // credit
    currentTrajet.credit,
    currentTrajet.mult_credit,
    // parking
    currentTrajet.parking,
    currentTrajet.mult_parking,
    //contravention
    currentTrajet.contravention,
    currentTrajet.mult_contravention,
    // arrimage
    currentTrajet.arrimage,
    currentTrajet.arrimage_multi,
    //chargement
    currentTrajet.chargement,
    currentTrajet.chargement_multi,
    //dechargement
    currentTrajet.dechargement_multi,
    currentTrajet.dechargement,
    // divers
    currentTrajet.divers,
    currentTrajet.mult_divers,
    // nb jours
    nombreJours,
    nombreJourParking,
    // cotation type
    currentTrajet.cotation_type,
    currentTrajet.coefficient_distance,
  ]);

  const handleStatusChange = (type, value) => {
    const coef =
      value === 1
        ? currentTrajet.coefficient_charge
        : currentTrajet.coefficient_vide;
    if (type === "aller") {
      setcurrentTrajet({
        ...currentTrajet,
        status_aller: value,
        coefficient_aller: coef,
      });
    } else {
      setcurrentTrajet({
        ...currentTrajet,
        status_retour: value,
        coefficient_retour: coef,
      });
    }
  };

  const fetchListeRegion = async () => {
    const res = await get_ListeRegion();
    setlisteRegion(res.data);
    const carb = await carburantConfig();
    setcurrentTrajet((prev) => ({
      ...prev,
      prix_gasoil: carb.prix_go,
      coefficient_charge: carb.coefficient_charge,
      coefficient_vide: carb.coefficient_vide,
      tva: carb.tva
    }));
  };

  const fetchListeClients = async () => {
    const res = await get_ListeClients();
    setListeClients(res.data);
  };

const handleGenerateDevis = () => {
  const { date_depart, date_arrive, region_depart, region_arrive,  client_id} = currentTrajet;

  if (!date_depart || !date_arrive || !region_depart || !region_arrive || !client_id) {
    console.log("Informations manquantes");

    alert(
      "Veuillez renseigner les dates et les régions de départ et d'arrivée ainsi que le nom du clients."
    );
    return;
  }

  setModalLimitePaiement(true);
};

  const handleConfirmGenerateDevis = async () => {
    setisloading(true)
    const payload = {
      ...currentTrajet,
      date_depart: currentTrajet.date_depart
        ? typeof currentTrajet.date_depart.format === "function"
          ? currentTrajet.date_depart.format("YYYY-MM-DD HH:mm:ss")
          : currentTrajet.date_depart
        : null,
      date_arrive: currentTrajet.date_arrive
        ? typeof currentTrajet.date_arrive.format === "function"
          ? currentTrajet.date_arrive.format("YYYY-MM-DD HH:mm:ss")
          : currentTrajet.date_arrive
        : null,
      jours_trajet: nombreJours,
      limite_paiement: currentTrajet.limite_paiement,
    };

    const res = await create_devis(payload);
    if (res.status === "success") {
      setnotif({
        ...notif,
        message: "Devis generé avec succés",
        info: "success",
      });
      setshowToast(true);
      setTimeout(() => {
        window.location.replace('/commerciale/devis');
      }, 1500);
    } else {
      message.warning("Erreur lors de la modification du chauffeur !!!");
      setnotif({
        ...notif,
        message: "Erreur lors de la modification du chauffeur !!!",
        info: "error",
      });
      setshowToast(true);
      setTimeout(() => {
        setshowToast(false);
      }, 1500);
      setisloading(false)
    }
  };

  const handleGenerateBennes = async () => {
    setisloading(true)
    const formattedBennes = currentBennes.map(benne => ({
      ...benne,
      date_location: benne.date_location
        ? typeof benne.date_location.format === "function"
          ? benne.date_location.format("YYYY-MM-DD HH:mm:ss")
          : benne.date_location
        : null
    }));

    const totalBennes = formattedBennes.reduce((acc, benne) => {
      return acc + (benne.total || 0);
    }, 0);

    const finalTrajet = {
      ...currentTrajet,
      date_depart: currentTrajet.date_depart?.format
        ? currentTrajet.date_depart.format("YYYY-MM-DD HH:mm:ss")
        : currentTrajet.date_depart,
      date_arrive: currentTrajet.date_arrive?.format
        ? currentTrajet.date_arrive.format("YYYY-MM-DD HH:mm:ss")
        : currentTrajet.date_arrive,
      bennes: formattedBennes,
      total_brute: totalBennes,
    };

    setcurrentTrajet(finalTrajet);

    console.log(finalTrajet);

    const res = await create_devis_bennes(finalTrajet);
    if (res['status'] === "success") {
      setnotif({
        ...notif,
        message: "Devis generé avec succés",
        info: "success",
      });
      setshowToast(true);
      setTimeout(() => {
        window.location.replace('/commerciale/devis');
      }, 1500);
    } else {
      message.warning("Erreur lors de la modification du chauffeur !!!");
      setnotif({
        ...notif,
        message: "Erreur lors de la modification du chauffeur !!!",
        info: "error",
      });
      setshowToast(true);
      setTimeout(() => {
        setshowToast(false);
      }, 1500);
      setisloading(false)
    }
  }

  const addBenne = () => {
    setcurrentBennes([
      ...currentBennes,
      { description: "Location benne", date_location: moment(), volumetrie: "20", type_location: "propre", quantite: 1, prix_unitaire: 0, total: 0 }
    ]);
  };

  // Supprimer une ligne
  const removeBenne = (index) => {
    const newBennes = currentBennes.filter((_, i) => i !== index);
    setcurrentBennes(newBennes);
  };

  const updateBenneField = (index, field, value) => {
    const newBennes = [...currentBennes];

    newBennes[index][field] = value;

    // 🔥 recalcul automatique du total
    const qte = newBennes[index].quantite || 0;
    const pu = newBennes[index].prix_unitaire || 0;

    newBennes[index].total = qte * pu;

    setcurrentBennes(newBennes);
  };

  const updateFrais = (field, value) => {
    setcurrentTrajet((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const addFraisLine = () => {
    setcurrentTrajet((prev) => ({
      ...prev,
      frais: [
        ...prev.frais,
        {
          type: null,
          montant: 0,
          multiplicateur: 1,
          total: 0,
        },
      ],
    }));
  };

  const removeFraisLine = (index) => {
    const newFrais = [...currentTrajet.frais];
    newFrais.splice(index, 1);

    setcurrentTrajet((prev) => ({
      ...prev,
      frais: newFrais,
    }));
  };

  const updateFraisLine = (index, field, value) => {
    const newFrais = [...currentTrajet.frais];

    newFrais[index][field] = value;

    // recalcul automatique
    const m = newFrais[index].montant || 0;
    const mult = newFrais[index].multiplicateur || 0;
    newFrais[index].total = m * mult;

    setcurrentTrajet((prev) => ({
      ...prev,
      frais: newFrais,
    }));
  };

  const lbl = { fontSize: 12, color: "rgba(0,0,0,0.65)", textAlign: "right", lineHeight: 1.2 };
  const ctl = { width: "100%", fontSize: 12 };
  const fmt = (v) => `${v ?? ""}`.replace(/\B(?=(\d{3})+(?!\d))/g, " ");
  const parse = (v) => v.replace(/\s/g, "");
  const set = (key) => (value) => setcurrentTrajet((prev) => ({ ...prev, [key]: value }));

  return (
    <div>
      <Steps
        current={currentStep}
        size="small"
        style={{ marginBottom: 20 }}
        items={[
          { title: "Services" },
          { title: "Informations principales" },
          { title: "Frais et dépenses" },
          { title: "Dotations et calculs" },
        ]}
      />

      {
        currentStep === 0 && (
          <Row gutter={24} justify="center" style={{ marginBottom: 30 }}>
            {/* Titre */}
            <Col span={24} style={{ textAlign: "center", marginBottom: 20 }}>
              <Text type="secondary">
                Sélectionnez l’activité pour créer votre devis.
              </Text>
            </Col>

            {/* Carte Transport */}
            <Col span={10}>
              <Card
                hoverable
                onClick={() =>
                  setcurrentTrajet(prev => ({
                    ...prev,
                    type_devis: "transport",
                  }))

                }
                style={{
                  borderRadius: 18,
                  textAlign: "center",
                  border:
                    currentTrajet.type_devis === "transport"
                      ? "2px solid #1677ff"
                      : "1px solid #ddd",
                  boxShadow:
                    currentTrajet.type_devis === "transport"
                      ? "0 0 12px rgba(22,119,255,0.4)"
                      : "0 2px 8px rgba(0,0,0,0.05)",
                }}
              >
                <TruckOutlined style={{ fontSize: 55, color: "#1677ff" }} />

                <Title level={4} style={{ marginTop: 15 }}>
                  Transport
                </Title>

                <Text type="secondary">
                  Devis pour le transport de marchandises.
                </Text>

                <div
                  style={{
                    marginTop: 20,
                    padding: "10px 0",
                    borderRadius: 12,
                    background:
                      currentTrajet.type_devis === "transport"
                        ? "#1677ff"
                        : "#f5f5f5",
                    color:
                      currentTrajet.type_devis === "transport"
                        ? "white"
                        : "#333",
                    fontWeight: 600,
                  }}
                >
                  Choisir Transport
                </div>
              </Card>
            </Col>

            {/* Carte Benne */}
            <Col span={10}>
              <Card
                hoverable
                onClick={() =>
                  setcurrentTrajet(prev => ({
                    ...prev,
                    type_devis: "benne",
                  }))
                }
                style={{
                  borderRadius: 18,
                  textAlign: "center",
                  border:
                    currentTrajet.type_devis === "benne"
                      ? "2px solid #52c41a"
                      : "1px solid #ddd",
                  boxShadow:
                    currentTrajet.type_devis === "benne"
                      ? "0 0 12px rgba(82,196,26,0.4)"
                      : "0 2px 8px rgba(0,0,0,0.05)",
                }}
              >
                <InboxOutlined style={{ fontSize: 55, color: "#52c41a" }} />

                <Title level={4} style={{ marginTop: 15 }}>
                  Location Benne
                </Title>

                <Text type="secondary">
                  Devis pour la location de bennes.
                </Text>

                <div
                  style={{
                    marginTop: 20,
                    padding: "10px 0",
                    borderRadius: 12,
                    background:
                      currentTrajet.type_devis === "benne"
                        ? "#52c41a"
                        : "#f5f5f5",
                    color:
                      currentTrajet.type_devis === "benne"
                        ? "white"
                        : "#333",
                    fontWeight: 600,
                  }}
                >
                  Choisir Benne
                </div>
              </Card>
            </Col>
          </Row>
        )
      }

      {currentStep === 1 && currentTrajet.type_devis === 'transport' && (
        <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
          {/* Ligne 1: Clients */}
          <Row gutter={16}>
            <Col span={12}>
              <Row align="middle" gutter={8}>
                <Col span={10} style={{ textAlign: "center" }}>
                  Clients
                </Col>
                <Col span={14}>
                  <Select
                    showSearch
                    optionFilterProp="children"
                    size="medium"
                    placeholder="Clients"
                    style={{
                      width: "100%",
                      textAlign: "center",
                      fontWeight: 600,
                    }}
                    value={currentTrajet.client_id}
                    onChange={(value) =>
                      setcurrentTrajet(prev => ({
                        ...prev,
                        client_id: value,
                      }))
                    }
                  >
                    {listeClient.map((r) => (
                      <Option key={r.id} value={r.id}>
                        {r.nom}
                      </Option>
                    ))}
                  </Select>
                </Col>
              </Row>
            </Col>
          </Row>
          {/* Ligne 1: Date départ / Date arrivée */}
          <Row gutter={16}>
            <Col span={12}>
              <Row align="middle" gutter={8}>
                <Col span={10} style={{ textAlign: "center" }}>
                  Date départ
                </Col>
                <Col span={14}>
                  <DatePicker
                    size="small"
                    showTime
                    style={{ width: "100%" }}
                    format="YYYY-MM-DD HH:mm:ss"
                    value={currentTrajet.date_depart || null}

                    onChange={(date) =>
                      setcurrentTrajet(prev => ({
                        ...prev,
                        date_depart: date,
                      }))
                    }
                  />
                </Col>
              </Row>
            </Col>
            <Col span={12}>
              <Row align="middle" gutter={8}>
                <Col span={10} style={{ textAlign: "center" }}>
                  Date arrivée
                </Col>
                <Col span={14}>
                  <DatePicker
                    size="small"
                    showTime
                    style={{ width: "100%" }}
                    format="YYYY-MM-DD HH:mm:ss"
                    value={currentTrajet.date_arrive || null}

                    onChange={(date) =>
                      setcurrentTrajet(prev => ({
                        ...prev,
                        date_arrive: date,
                      }))
                    }
                  />
                </Col>
              </Row>
            </Col>
          </Row>
          {/* Durée du trajet calculée */}
          <Row gutter={16}>
            <Col span={24} style={{ textAlign: "center" }}>
              <Text type="secondary">
                Durée du trajet : <b>{nombreJours}</b> jour{nombreJours > 1 ? "s" : ""}
              </Text>
            </Col>
          </Row>
          <br />
          {/* Ligne 2: Région départ / Région arrivée */}
          <Row gutter={16}>
            <Col span={12}>
              <Row align="middle" gutter={8}>
                <Col span={10} style={{ textAlign: "center" }}>
                  Région départ
                </Col>
                <Col span={14}>
                  <Select
                    showSearch
                    optionFilterProp="children"
                    size="medium"
                    placeholder="Choisir la région"
                    style={{ width: "100%" }}
                    value={currentTrajet.region_depart}
                    onChange={(value) =>
                      setcurrentTrajet(prev => ({
                        ...prev,
                        region_depart: value,
                      }))
                    }
                  >
                    {listeRegion.map((r) => (
                      <Option key={r.id} value={r.id}>
                        {r.nom}
                      </Option>
                    ))}
                  </Select>
                </Col>
              </Row>
            </Col>
            <Col span={12}>
              <Row align="middle" gutter={8}>
                <Col span={10} style={{ textAlign: "center" }}>
                  Région arrivée
                </Col>
                <Col span={14}>
                  <Select
                    showSearch
                    optionFilterProp="children"
                    size="medium"
                    placeholder="Choisir la région"
                    style={{ width: "100%" }}
                    value={currentTrajet.region_arrive}
                    onChange={(value) =>
                      setcurrentTrajet(prev => ({
                        ...prev,
                        region_arrive: value,
                      }))
                    }
                  >
                    {listeRegion.map((r) => (
                      <Option key={r.id} value={r.id}>
                        {r.nom}
                      </Option>
                    ))}
                  </Select>
                </Col>
              </Row>
            </Col>
          </Row>
          <br />
          {/* Ligne 3: Distance / Poids */}
          <Row gutter={16}>
            <Col span={12}>
              <Row align="middle" gutter={8}>
                <Col span={10} style={{ textAlign: "center" }}>
                  Distance (km)
                </Col>
                <Col span={14}>
                  <InputNumber
                    size="small"
                    min={0}
                    style={{ width: "100%" }}
                    value={currentTrajet.distance}
                    onChange={(value) =>
                      setcurrentTrajet(prev => ({
                        ...prev,
                        distance: value,
                      }))
                    }

                  />
                </Col>
              </Row>
            </Col>
            <Col span={12}>
              <Row align="middle" gutter={8}>
                <Col span={10} style={{ textAlign: "center" }}>
                  Poids (kg)
                </Col>
                <Col span={14}>
                  <InputNumber
                    size="small"
                    min={0}
                    style={{ width: "100%" }}
                    value={currentTrajet.poids}
                    onChange={(value) =>
                      setcurrentTrajet(prev => ({
                        ...prev,
                        poids: value,
                      }))
                    }
                  />
                </Col>
              </Row>
            </Col>
          </Row>
          <br />
          {/* Description */}
          <Row gutter={16}>
            <Col span={24}>
              <Row align="middle" gutter={8}>
                <Col span={5} style={{ textAlign: "center" }}>
                  Description
                </Col>
                <Col span={19}>
                  <TextArea
                    rows={3}
                    placeholder="Notes, incidents, remarques…"
                    value={currentTrajet.description}
                    onChange={(e) =>
                      setcurrentTrajet(prev => ({
                        ...prev,
                        description: e.target.value,
                      }))
                    }
                  />
                </Col>
              </Row>
            </Col>
          </Row>
        </div>
      )}

      {currentStep === 1 && currentTrajet.type_devis === 'benne' && (
        <div style={{ display: "flex", flexDirection: "column", gap: 16, height: '60vh', overflowY: 'auto', overflowX: 'hidden' }}>
          <Text strong style={{ fontSize: 16 }}>Location de bennes</Text>
          <Row gutter={16}>
            <Col span={12}>
              <Row align="middle" gutter={8}>

                <Col span={10}>
                  <Select
                    showSearch
                    optionFilterProp="children"
                    size="small"
                    placeholder="Clients"
                    style={{
                      width: "100%",
                      textAlign: "center",
                      fontWeight: 600,
                    }}
                    value={currentTrajet.client_id}
                    onChange={(value) =>
                      setcurrentTrajet(prev => ({
                        ...prev,
                        client_id: value,
                      }))
                    }
                  >
                    {listeClient.map((r) => (
                      <Option key={r.id} value={r.id}>
                        {r.nom}
                      </Option>
                    ))}
                  </Select>
                </Col>
              </Row>
            </Col>
            <Col span={8}>
              <Row align="middle" gutter={8}>
                <Col span={10} style={{ textAlign: "center" }}>
                  Mode de paiement
                </Col>
                <Col span={14}>
                  <Select showSearch
                    optionFilterProp="children"
                    size="small"
                    style={{
                      width: "100%",
                      textAlign: "center",
                      fontWeight: 600,
                    }}
                    value={currentTrajet.paiement}
                    onChange={(value) =>
                      setcurrentTrajet(prev => ({
                        ...prev,
                        paiement: value,
                      }))
                    }
                  >
                    <Option key="cheque" value="cheque"></Option>
                    <Option key="mobile_money" value="Mobile Money"></Option>
                    <Option key="espece" value="Espèces"></Option>
                    <Option key="virement" value="Virement bancaire"></Option>
                  </Select>
                </Col>
              </Row>
            </Col>
          </Row>
          <br />
          {currentBennes.map((benne, index) => (
            <div
              key={index}
              style={{
                background: "#fff",
                padding: 18,
                borderRadius: 16,
                marginBottom: 14,
                border: "1px solid #f0f0f0",
                boxShadow: "0 3px 10px rgba(0,0,0,0.06)",
              }}
            >
              {/* Header */}
              <Row align="right">
                <Button
                  danger
                  type="text"
                  onClick={() => removeBenne(index)}
                  style={{ fontWeight: 500, float: "right" }}
                >
                  🗑 Supprimer
                </Button>
              </Row>

              <div style={{ marginTop: 12 }} />

              {/* Formulaire */}
              <Row gutter={[12, 12]} align="middle">
                {/* Description */}
                <Col xs={24} md={6}>
                  <label className="field-label">Description</label>
                  <Input
                    placeholder="Ex: Benne gravats"
                    value={benne.description}
                    onChange={(e) =>
                      updateBenneField(index, "description", e.target.value)
                    }
                  />
                </Col>

                {/* Date */}
                <Col xs={12} md={4}>
                  <label className="field-label">Date</label>
                  <DatePicker
                    style={{ width: "100%" }}
                    value={benne.date_location}
                    format="YYYY-MM-DD"
                    onChange={(date) =>
                      updateBenneField(index, "date_location", date)
                    }
                  />
                </Col>

                {/* Volume */}
                <Col xs={12} md={3}>
                  <label className="field-label">Volume</label>
                  <Select showSearch
                    optionFilterProp="children"
                    placeholder="m³"
                    value={benne.volumetrie}
                    style={{ width: "100%" }}
                    onChange={(val) =>
                      updateBenneField(index, "volumetrie", val)
                    }
                  >
                    {volumetries.map((v) => (
                      <Option key={v.value} value={v.value}>
                        {v.label}
                      </Option>
                    ))}
                  </Select>
                </Col>

                {/* Type */}
                <Col xs={12} md={4}>
                  <label className="field-label">Type</label>
                  <Select showSearch
                    optionFilterProp="children"
                    placeholder="Location / Propre"
                    value={benne.type_location}
                    style={{ width: "100%" }}
                    onChange={(val) =>
                      updateBenneField(index, "type_location", val)
                    }
                  >
                    {locationTypes.map((t) => (
                      <Option key={t.value} value={t.value}>
                        {t.label}
                      </Option>
                    ))}
                  </Select>
                </Col>

                {/* Quantité */}
                <Col xs={12} md={2}>
                  <label className="field-label">Qté</label>
                  <InputNumber
                    min={1}
                    value={benne.quantite}
                    style={{ width: "100%" }}
                    onChange={(val) =>
                      updateBenneField(index, "quantite", val)
                    }
                  />
                </Col>

                {/* Prix */}
                <Col xs={12} md={3}>
                  <label className="field-label">PU</label>
                  <InputNumber
                    min={0}
                    value={benne.prix_unitaire}
                    style={{ width: "100%" }}
                    formatter={(v) =>
                      `${v}`.replace(/\B(?=(\d{3})+(?!\d))/g, " ")
                    }
                    onChange={(val) =>
                      updateBenneField(index, "prix_unitaire", val)
                    }
                  />
                </Col>

                {/* Total */}
                <Col xs={12} md={2}>
                  <label className="field-label">Total</label>
                  <InputNumber
                    value={benne.total}
                    disabled
                    style={{
                      width: "100%",
                      fontWeight: "bold",
                      background: "#f6ffed",
                      border: "1px solid #b7eb8f",
                    }}
                    formatter={(v) =>
                      `${v}`.replace(/\B(?=(\d{3})+(?!\d))/g, " ")
                    }
                  />
                </Col>
              </Row>
            </div>
          ))}
          <Button type="dashed" onClick={addBenne} style={{ width: "50%", alignSelf: "center" }}>
            + Ajouter
          </Button>
          <div
            style={{
              background: "#fff",
              padding: 20,
              borderRadius: 16,
              border: "1px solid #eee",
              boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
            }}
          >
            {/* Header */}
            <Row justify="space-between" align="middle">
              <h5 style={{ margin: 0 }}>💰 Frais & Perdiems</h5>

              <Button type="primary" onClick={addFraisLine}>
                + Ajouter un frais
              </Button>
            </Row>
            <div style={{ marginTop: 20 }} />
            {/* Liste dynamique */}
            {currentTrajet.frais.map((frais, index) => (
              <div
                key={index}
                style={{
                  padding: 14,
                  marginBottom: 12,
                  borderRadius: 14,
                  border: "1px solid #f0f0f0",
                  background: "#fafafa",
                }}
              >
                <Row gutter={[12, 12]} align="middle">
                  {/* Type */}
                  <Col xs={24} md={6}>
                    <Select showSearch
                      optionFilterProp="children"
                      placeholder="Type de frais"
                      style={{ width: "100%" }}
                      value={frais.type}
                      onChange={(val) =>
                        updateFraisLine(index, "type", val)
                      }
                    >
                      {fraisTypes.map((t) => (
                        <Option key={t.value} value={t.value}>
                          {t.label}
                        </Option>
                      ))}
                    </Select>
                  </Col>

                  {/* Montant */}
                  <Col xs={12} md={5}>
                    <InputNumber
                      min={0}
                      placeholder="Montant"
                      style={{ width: "100%" }}
                      value={frais.montant}
                      onChange={(val) =>
                        updateFraisLine(index, "montant", val)
                      }
                      formatter={(v) =>
                        `${v}`.replace(/\B(?=(\d{3})+(?!\d))/g, " ")
                      }
                    />
                  </Col>

                  {/* Multiplicateur */}
                  <Col xs={12} md={3}>
                    <InputNumber
                      min={1}
                      placeholder="N"
                      style={{ width: "100%" }}
                      value={frais.multiplicateur}
                      onChange={(val) =>
                        updateFraisLine(index, "multiplicateur", val)
                      }
                    />
                  </Col>

                  {/* Total */}
                  <Col xs={12} md={5}>
                    <InputNumber
                      disabled
                      style={{
                        width: "100%",
                        fontWeight: "bold",
                        background: "#f6ffed",
                        border: "1px solid #b7eb8f",
                      }}
                      value={frais.total}
                      formatter={(v) =>
                        `${v}`.replace(/\B(?=(\d{3})+(?!\d))/g, " ")
                      }
                    />
                  </Col>

                  {/* Supprimer */}
                  <Col xs={12} md={2}>
                    <Button danger onClick={() => removeFraisLine(index)}>
                      ✕
                    </Button>
                  </Col>
                </Row>
              </div>
            ))}
          </div>


        </div>

      )}

      {currentStep === 2 && (
        <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
          {/* Ligne 1: Per diem chauffeur et Per diem aide */}
          <Row gutter={16}>
            <Col span={12}>
              <Row align="middle" gutter={8}>
                <Col span={10} style={{ textAlign: "center" }}>
                  Per diem chauffeur (Ar)
                </Col>
                <Col span={14}>
                  <Row align="middle" gutter={8}>
                    <Col span={9}>
                      <InputNumber
                        size="small"
                        min={0}
                        style={{ width: "100%" }}
                        value={currentTrajet.perdiem_chauffeur}
                        onChange={(value) =>
                          setcurrentTrajet(prev => ({
                            ...prev,
                            perdiem_chauffeur: value,
                          }))
                        }
                        formatter={(value) =>
                          `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, " ")
                        }
                        parser={(value) => value.replace(/\s?/g, "")}
                      />
                    </Col>
                    {/* <Col span={3}>
                      <span style={{ whiteSpace: "nowrap" }}>
                        × {nombreJours || 0} j
                      </span> 
                    </Col> */}
                    <Col span={4}>
                      <InputNumber
                        size="small"
                        min={0}
                        placeholder="N"
                        style={{ width: "100%" }}
                        value={currentTrajet.multi_perdiem_chauffeur || 0}
                        onChange={(value) =>
                          setcurrentTrajet(prev => ({
                            ...prev,
                            multi_perdiem_chauffeur: value,
                          }))
                        }

                      />
                    </Col>
                    <Col span={11}>
                      <InputNumber
                        size="small"
                        style={{ width: "100%" }}
                        value={
                          (currentTrajet.perdiem_chauffeur || 0) *
                          (currentTrajet.multi_perdiem_chauffeur || 0)
                        }
                        disabled
                        formatter={(value) =>
                          `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, " ")
                        }
                        parser={(value) => value.replace(/\s?/g, "")}

                      />
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Col>

            <Col span={12}>
              <Row align="middle" gutter={8}>
                <Col span={10} style={{ textAlign: "center" }}>
                  Per diem Aide chauffeur (Ar)
                </Col>
                <Col span={14}>
                  <Row align="middle" gutter={8}>
                    <Col span={9}>
                      <InputNumber
                        size="small"
                        min={0}
                        style={{ width: "100%" }}
                        value={currentTrajet.perdiem_aide}
                        onChange={(value) =>
                          setcurrentTrajet(prev => ({
                            ...prev,
                            perdiem_aide: value,
                          }))
                        }
                        formatter={(value) =>
                          `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, " ")
                        }
                        parser={(value) => value.replace(/\s?/g, "")}
                      />
                    </Col>
                    {/* <Col span={3}>
                      <span style={{ whiteSpace: "nowrap" }}>
                        × {nombreJours || 0} j
                      </span>
                    </Col> */}
                    <Col span={4}>
                      <InputNumber
                        size="small"
                        min={0}
                        placeholder="N"
                        style={{ width: "100%" }}
                        value={currentTrajet.multi_perdiem_aide || 0}
                        onChange={(value) =>
                          setcurrentTrajet(prev => ({
                            ...prev,
                            multi_perdiem_aide: value,
                          }))
                        }

                      />
                    </Col>
                    <Col span={11}>
                      <InputNumber
                        size="small"
                        style={{ width: "100%" }}
                        value={
                          (currentTrajet.perdiem_aide || 0) * (currentTrajet.multi_perdiem_aide || 0)
                        }
                        disabled
                        formatter={(value) =>
                          `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, " ")
                        }
                        parser={(value) => value.replace(/\s?/g, "")}
                      />
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Col>
          </Row>
          <br />
          {/* Ligne 2: Crédit et Parking */}
          <Row gutter={16}>
            <Col span={12}>
              <Row align="middle" gutter={8}>
                <Col span={10} style={{ textAlign: "center" }}>
                  Crédit (Ar)
                </Col>
                <Col span={14}>
                  <Row align="middle" gutter={8}>
                    <Col span={8} flex="auto">
                      <InputNumber
                        size="small"
                        min={0}
                        style={{ width: "100%" }}
                        value={currentTrajet.credit}
                        onChange={(value) =>
                          setcurrentTrajet(prev => ({
                            ...prev,
                            credit: value,
                          }))
                        }

                        formatter={(value) =>
                          `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, " ")
                        }
                        parser={(value) => value.replace(/\s?/g, "")}
                      />
                    </Col>
                    <Col span={1}>
                      <span style={{ fontWeight: "bold" }}>×</span>
                    </Col>
                    <Col span={4}>
                      <InputNumber
                        size="small"
                        min={0}
                        placeholder="N"
                        style={{ width: "100%" }}
                        value={currentTrajet.mult_credit || 0}
                        onChange={(value) =>
                          setcurrentTrajet(prev => ({
                            ...prev,
                            mult_credit: value,
                          }))
                        }

                      />
                    </Col>
                    <Col span={10} flex="auto">
                      <InputNumber
                        size="small"
                        style={{ width: "100%" }}
                        value={
                          (currentTrajet.credit || 0) *
                          (currentTrajet.mult_credit || 0)
                        }
                        formatter={(value) =>
                          `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, " ")
                        }
                        parser={(value) => value.replace(/\s?/g, "")}
                      />
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Col>

            <Col span={12}>
              <Row align="middle" gutter={8}>
                <Col span={10} style={{ textAlign: "center" }}>
                  Parking (Ar)
                </Col>
                <Col span={14}>
                  <Row align="middle" gutter={8}>
                    <Col span={9} flex="auto">
                      <InputNumber
                        size="small"
                        min={0}
                        style={{ width: "100%" }}
                        value={currentTrajet.parking}
                        onChange={(value) =>
                          setcurrentTrajet(prev => ({
                            ...prev,
                            parking: value,
                          }))
                        }

                        formatter={(value) =>
                          `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, " ")
                        }
                        parser={(value) => value.replace(/\s?/g, "")}
                      />
                    </Col>
                    {/* <Col span={3}>
                      <span style={{ whiteSpace: "nowrap" }}>
                        × {nombreJourParking || 0} j
                      </span>
                    </Col> */
                      <Col span={4}>
                        <InputNumber
                          size="small"
                          min={0}
                          placeholder="N"
                          style={{ width: "100%" }}
                          value={currentTrajet.mult_parking || 0}
                          onChange={(value) =>
                            setcurrentTrajet(prev => ({
                              ...prev,
                              mult_parking: value,
                            }))
                          }

                        />
                      </Col>}

                    <Col span={11}>
                      <InputNumber
                        size="small"
                        min={0}
                        placeholder="N"
                        style={{ width: "100%" }}
                        value={
                          (currentTrajet.parking || 0) *
                          (currentTrajet.mult_parking || 0)
                        }
                        disabled
                        formatter={(value) =>
                          `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, " ")
                        }
                        parser={(value) => value.replace(/\s?/g, "")}
                      />
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Col>
          </Row>
          <br />
          {/* Ligne 3: Contravention et Divers */}
          <Row gutter={16}>
            <Col span={12}>
              <Row align="middle" gutter={8}>
                <Col span={10} style={{ textAlign: "center" }}>
                  Contravention (Ar)
                </Col>
                <Col span={14}>
                  <Row align="middle" gutter={8}>
                    <Col span={8} flex="auto">
                      <InputNumber
                        size="small"
                        min={0}
                        style={{ width: "100%" }}
                        value={currentTrajet.contravention}
                        onChange={(value) =>
                          setcurrentTrajet(prev => ({
                            ...prev,
                            contravention: value,
                          }))
                        }

                        formatter={(value) =>
                          `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, " ")
                        }
                        parser={(value) => value.replace(/\s?/g, "")}
                      />
                    </Col>
                    <Col span={1}>
                      <span style={{ fontWeight: "bold" }}>×</span>
                    </Col>
                    <Col span={4}>
                      <InputNumber
                        size="small"
                        min={0}
                        placeholder="N"
                        style={{ width: "100%" }}
                        value={currentTrajet.mult_contravention || 0}
                        onChange={(value) =>
                          setcurrentTrajet(prev => ({
                            ...prev,
                            mult_contravention: value,
                          }))
                        }

                      />
                    </Col>
                    <Col span={10} flex="auto">
                      <InputNumber
                        size="small"
                        style={{ width: "100%" }}
                        value={
                          (currentTrajet.contravention || 0) *
                          (currentTrajet.mult_contravention || 0)
                        }
                        formatter={(value) =>
                          `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, " ")
                        }
                        parser={(value) => value.replace(/\s?/g, "")}
                      />
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Col>

            <Col span={12}>
              <Row align="middle" gutter={8}>
                <Col span={10} style={{ textAlign: "center" }}>
                  Divers (Ar)
                </Col>
                <Col span={14}>
                  <Row align="middle" gutter={8}>
                    <Col span={8} flex="auto">
                      <InputNumber
                        size="small"
                        min={0}
                        style={{ width: "100%" }}
                        value={currentTrajet.divers}
                        onChange={(value) =>
                          setcurrentTrajet(prev => ({
                            ...prev,
                            divers: value,
                          }))
                        }


                        formatter={(value) =>
                          `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, " ")
                        }
                        parser={(value) => value.replace(/\s?/g, "")}
                      />
                    </Col>
                    <Col span={1}>
                      <span style={{ fontWeight: "bold" }}>×</span>
                    </Col>
                    <Col span={4}>
                      <InputNumber
                        size="small"
                        min={1}
                        placeholder="N"
                        style={{ width: "100%" }}
                        value={currentTrajet.mult_divers || 0}
                        onChange={(value) =>
                          setcurrentTrajet(prev => ({
                            ...prev,
                            mult_divers: value,
                          }))
                        }

                      />
                    </Col>
                    <Col span={10} flex="auto">
                      <InputNumber
                        size="small"
                        style={{ width: "100%" }}
                        value={
                          (currentTrajet.divers || 0) *
                          (currentTrajet.mult_divers || 0)
                        }
                        formatter={(value) =>
                          `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, " ")
                        }
                        parser={(value) => value.replace(/\s?/g, "")}
                      />
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Col>
          </Row>
          {/* Ligne 4 chargement*/}
          <Row gutter={16}>
            <Col span={12}>
              <Row align="middle" gutter={8}>
                <Col span={10} style={{ textAlign: "center" }}>
                  Chargement (Ar)
                </Col>
                <Col span={14}>
                  <Row align="middle" gutter={8}>
                    <Col span={8} flex="auto">
                      <InputNumber
                        size="small"
                        min={1}
                        style={{ width: "100%" }}
                        value={currentTrajet.chargement}
                        onChange={(value) =>
                          setcurrentTrajet(prev => ({
                            ...prev,
                            chargement: value,
                          }))
                        }

                        formatter={(value) =>
                          `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, " ")
                        }
                        parser={(value) => value.replace(/\s?/g, "")}
                      />
                    </Col>
                    <Col span={1}>
                      <span style={{ fontWeight: "bold" }}>×</span>
                    </Col>
                    <Col span={4}>
                      <InputNumber
                        size="small"
                        min={1}
                        placeholder="N"
                        style={{ width: "100%" }}
                        value={currentTrajet.chargement_multi || 0}

                        onChange={(value) =>
                          setcurrentTrajet(prev => ({
                            ...prev,
                            chargement_multi: value,
                          }))
                        }

                      />
                    </Col>
                    <Col span={10} flex="auto">
                      <InputNumber
                        size="small"
                        style={{ width: "100%" }}
                        value={
                          (currentTrajet.chargement || 0) *
                          (currentTrajet.chargement_multi || 0)
                        }
                        formatter={(value) =>
                          `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, " ")
                        }
                        parser={(value) => value.replace(/\s?/g, "")}
                      />
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Col>

            <Col span={12}>
              <Row align="middle" gutter={8}>
                <Col span={10} style={{ textAlign: "center" }}>
                  Déchargement (Ar)
                </Col>
                <Col span={14}>
                  <Row align="middle" gutter={8}>
                    <Col span={8} flex="auto">
                      <InputNumber
                        size="small"
                        min={0}
                        style={{ width: "100%" }}
                        value={currentTrajet.dechargement}

                        onChange={(value) =>
                          setcurrentTrajet(prev => ({
                            ...prev,
                            dechargement: value,
                          }))
                        }

                        formatter={(value) =>
                          `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, " ")
                        }
                        parser={(value) => value.replace(/\s?/g, "")}
                      />
                    </Col>
                    <Col span={1}>
                      <span style={{ fontWeight: "bold" }}>×</span>
                    </Col>
                    <Col span={4}>
                      <InputNumber
                        size="small"
                        min={1}
                        placeholder="N"
                        style={{ width: "100%" }}
                        value={currentTrajet.dechargement_multi || 0}
                        onChange={(value) =>
                          setcurrentTrajet(prev => ({
                            ...prev,
                            dechargement_multi: value,
                          }))
                        }
                      />
                    </Col>
                    <Col span={10} flex="auto">
                      <InputNumber
                        size="small"
                        style={{ width: "100%" }}
                        value={
                          (currentTrajet.dechargement || 0) *
                          (currentTrajet.dechargement_multi || 0)
                        }
                        formatter={(value) =>
                          `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, " ")
                        }
                        parser={(value) => value.replace(/\s?/g, "")}
                      />
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Col>
          </Row>
          {/* Ligne 5 arrimage*/}
          <Row gutter={16}>
            <Col span={12}>
              <Row align="middle" gutter={8}>
                <Col span={10} style={{ textAlign: "center" }}>
                  Arrimage (Ar)
                </Col>
                <Col span={14}>
                  <Row align="middle" gutter={8}>
                    <Col span={8} flex="auto">
                      <InputNumber
                        size="small"
                        min={1}
                        style={{ width: "100%" }}
                        value={currentTrajet.arrimage}
                        onChange={(value) =>
                          setcurrentTrajet(prev => ({
                            ...prev,
                            arrimage: value,
                          }))
                        }

                        formatter={(value) =>
                          `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, " ")
                        }
                        parser={(value) => value.replace(/\s?/g, "")}
                      />
                    </Col>
                    <Col span={1}>
                      <span style={{ fontWeight: "bold" }}>×</span>
                    </Col>
                    <Col span={4}>
                      <InputNumber
                        size="small"
                        min={1}
                        placeholder="N"
                        style={{ width: "100%" }}
                        value={currentTrajet.arrimage_multi || 0}
                        onChange={(value) =>
                          setcurrentTrajet(prev => ({
                            ...prev,
                            arrimage_multi: value,
                          }))
                        }

                      />
                    </Col>
                    <Col span={10} flex="auto">
                      <InputNumber
                        size="small"
                        style={{ width: "100%" }}
                        value={
                          (currentTrajet.arrimage || 0) *
                          (currentTrajet.arrimage_multi || 0)
                        }
                        formatter={(value) =>
                          `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, " ")
                        }
                        parser={(value) => value.replace(/\s?/g, "")}
                      />
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Col>
          </Row>
        </div>
      )}

      {currentStep === 3 && currentTrajet.type_devis === 'transport' && (
        <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
          {/* Ligne 1: Coefficient chargé et Coefficient vide */}
          {/* <Row gutter={16}>
            <Col span={12}>
              <Row align="middle" gutter={8}>
                <Col span={10} style={{ textAlign: "center" }}>
                  Coefficient chargé
                </Col>
                <Col span={8}>
                  <InputNumber
                    size="small"
                    min={0}
                    step={100}
                    style={{
                      width: "100%",
                    }}
                    value={currentTrajet.coefficient_charge}
                    onChange={(value) =>
                      setcurrentTrajet(prev => ({
                        ...prev,
                        coefficient_charge: value,
                      }))
                    }

                  />
                </Col>
              </Row>
            </Col>

            <Col span={12}>
              <Row align="middle" gutter={8}>
                <Col span={10} style={{ textAlign: "center" }}>
                  Coefficient vide
                </Col>
                <Col span={8}>
                  <InputNumber
                    size="small"
                    min={0}
                    step={100}
                    style={{ width: "100%" }}
                    value={currentTrajet.coefficient_vide}
                    onChange={(value) =>
                      setcurrentTrajet(prev => ({
                        ...prev,
                        coefficient_vide: value,
                      }))
                    }


                  />
                </Col>
              </Row>
            </Col>
          </Row> */}

          {/* Ligne 2: Status Aller et Status Retour */}
          {/* <Row gutter={16}>
            <Col span={12}>
              <Row align="middle" gutter={8}>
                <Col span={8} style={{ textAlign: "center" }}>
                  Status Aller
                </Col>
                <Col span={8}>
                  <Radio.Group
                    value={currentTrajet.status_aller}
                    onChange={(e) =>
                      handleStatusChange("aller", e.target.value)
                    }
                  >
                    <Radio value={1}>Chargé</Radio>
                    <Radio value={0}>Vide</Radio>
                  </Radio.Group>
                </Col>
              </Row>
            </Col>
            <Col span={12}>
              <Row align="middle" gutter={8}>
                <Col span={10} style={{ textAlign: "center" }}>
                  Status Retour
                </Col>
                <Col span={14}>
                  <Radio.Group
                    value={currentTrajet.status_retour}
                    onChange={(e) =>
                      handleStatusChange("retour", e.target.value)
                    }
                  >
                    <Radio value={1}>Chargé</Radio>
                    <Radio value={0}>Vide</Radio>
                  </Radio.Group>
                </Col>
              </Row>
            </Col>
          </Row> */}

          {/* Ligne 3: Prix gasoil et Carburant total */}
          {/* <Row gutter={16}>
            <Col span={12}>
              <Row align="middle" gutter={8}>
                <Col span={10} style={{ textAlign: "center" }}>
                  Prix du gasoil (Ar/L)
                </Col>
                <Col span={14}>
                  <InputNumber
                    size="small"
                    min={0}
                    step={100}
                    style={{ width: "100%" }}
                    value={currentTrajet.prix_gasoil}
                    onChange={(value) =>
                      setcurrentTrajet(prev => ({
                        ...prev,
                        prix_gasoil: value,
                      }))
                    }

                    formatter={(value) =>
                      `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, " ")
                    }
                    parser={(value) => value.replace(/\s?/g, "")}
                  />
                </Col>
              </Row>
            </Col>

            <Col span={12}>
              <Row align="middle" gutter={8}>
                <Col span={10} style={{ textAlign: "center" }}>
                  Carburant total (L)
                </Col>
                <Col span={14}>
                  <InputNumber
                    size="small"
                    style={{ width: "100%" }}
                    value={currentTrajet.carburant}
                  />
                </Col>
              </Row>
            </Col>
          </Row> */}

          {/* Ligne 4: Total gasoil et Cotation */}
          {/* <Row gutter={16}>
            <Col span={12}>
              <Row align="middle" gutter={8}>
                <Col span={10} style={{ textAlign: "center" }}>
                  Total gasoil (Ar)
                </Col>
                <Col span={14}>
                  <InputNumber
                    size="small"
                    style={{ width: "100%" }}
                    value={currentTrajet.total_gasoil}
                    formatter={(value) =>
                      `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, " ")
                    }
                    parser={(value) => value.replace(/\s?/g, "")}
                  />
                </Col>
              </Row>
            </Col>

            <Col span={12}>
              <Row align="middle" gutter={8}>
                <Col span={10} style={{ textAlign: "center" }}>
                  Cotation (Ar)
                </Col>
                <Col span={14}>
                  <Row align="middle" gutter={8}>
                    <Col span={8}>
                      <Select showSearch
                        optionFilterProp="children"
                        size="medium"
                        value={currentTrajet.cotation_type}
                        onChange={(value) =>
                          setcurrentTrajet(prev => ({
                            ...prev,
                            cotation_type: value,
                          }))
                        }
                        style={{ width: "100%", textAlign: "center" }}
                      >
                        <Option key="poids" value="poids">Poids</Option>
                        <Option key="distance" value="distance">Distance</Option>
                      </Select>
                    </Col>
                    <Col span={10}>
                      <Slider
                        min={0}
                        max={9000}
                        value={currentTrajet.cotation}
                        onChange={(value) =>
                          setcurrentTrajet(prev => ({
                            ...prev,
                            cotation: value,
                          }))
                        }

                      />
                    </Col>
                    <Col span={6}>
                      <InputNumber
                        size="small"
                        min={0}
                        style={{ width: "100%", textAlign: "center" }}
                        value={currentTrajet.cotation}
                        onChange={(value) =>
                          setcurrentTrajet(prev => ({
                            ...prev,
                            cotation: value,
                          }))
                        }
                      />
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Col>
          </Row> */}

          {/* Ligne 6: Total dépense et frais */}
          {/* <Row gutter={16}>
            <Col span={12}>
              <Row align="middle" gutter={8}>
                <Col span={10} style={{ textAlign: "center" }}>
                  Total dépense et frais (Ar)
                </Col>
                <Col span={14}>
                  <InputNumber
                    size="small"
                    min={0}
                    style={{ width: "100%" }}
                    value={currentTrajet.total_frais}
                    onChange={(value) =>
                      setcurrentTrajet(prev => ({
                        ...prev,
                        total_frais: value,
                      }))
                    }

                    formatter={(value) =>
                      `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, " ")
                    }
                    parser={(value) => value.replace(/\s?/g, "")}
                  />
                </Col>
              </Row>
            </Col>

            <Col span={12}>
              <Row align="middle" gutter={8}>
                <Col span={10} style={{ textAlign: "center" }}>
                  Total brut (Ar)
                </Col>
                <Col span={14}>
                  <InputNumber
                    size="small"
                    min={0}
                    style={{ width: "100%" }}
                    value={currentTrajet.total_brute}
                    onChange={(value) =>
                      setcurrentTrajet(prev => ({
                        ...prev,
                        total_brute: value,
                      }))
                    }


                    formatter={(value) =>
                      `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, " ")
                    }
                    parser={(value) => value.replace(/\s?/g, "")}
                  />
                </Col>
              </Row>
            </Col>
          </Row> */}

          {/* Ligne 5: Total brut et Total bénéfice */}
          {/* <Row gutter={16}>
            <Col span={12}>
              <Row align="middle" gutter={8}>
                <Col span={10} style={{ textAlign: "center" }}>
                  TVA
                </Col>
                <Col span={14}>
                  <InputNumber
                    size="small"
                    min={0}
                    max={100}
                    style={{ width: "100%" }}
                    value={currentTrajet.tva}
                    onChange={(value) =>
                      setcurrentTrajet(prev => ({
                        ...prev,
                        tva: value,
                      }))
                    }

                    formatter={(value) =>
                      `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, " ")
                    }
                    parser={(value) => value.replace(/\s?/g, "")}
                  />
                </Col>
              </Row>
            </Col>
            <Col span={12}>
              <Row align="middle" gutter={8}>
                <Col span={10} style={{ textAlign: "center" }}>
                  Total bénéfice (Ar)
                </Col>
                <Col span={14}>
                  <InputNumber
                    size="small"
                    min={0}
                    style={{ width: "100%" }}
                    value={currentTrajet.total_benefice}
                    onChange={(value) =>
                      setcurrentTrajet(prev => ({
                        ...prev,
                        total_benefice: value,
                      }))
                    }

                    formatter={(value) =>
                      `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, " ")
                    }
                    parser={(value) => value.replace(/\s?/g, "")}
                  />
                </Col>
              </Row>
            </Col>
          </Row> */}
          {/* Ligne 5: Total brut et Total bénéfice */}
          {/* <Row gutter={16}>
            <Col span={12}>
              <Row align="middle" gutter={8}>
                <Col span={10} style={{ textAlign: "center" }}>
                  Acompte
                </Col>
                <Col span={14}>
                  <InputNumber
                    size="small"
                    min={0}
                    max={100}
                    style={{ width: "100%" }}
                    value={currentTrajet.acompte}
                    onChange={(value) =>
                      setcurrentTrajet(prev => ({
                        ...prev,
                        acompte: value,
                      }))
                    }


                    formatter={(value) =>
                      `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, " ")
                    }
                    parser={(value) => value.replace(/\s?/g, "")}
                  />
                </Col>
              </Row>
            </Col>
            <Col span={12}>
              <Row align="middle" gutter={8}>
                <Col span={10} style={{ textAlign: "center" }}>
                  Mode de paiement
                </Col>
                <Col span={14}>
                  <Select showSearch
                    optionFilterProp="children"
                    size="small"
                    style={{
                      width: "100%",
                      textAlign: "center",
                      fontWeight: 600,
                    }}
                    value={currentTrajet.paiement}
                    onChange={(value) =>
                      setcurrentTrajet(prev => ({
                        ...prev,
                        paiement: value,
                      }))
                    }
                  >
                    <Option key="cheque" value="cheque"></Option>
                    <Option key="mobile_money" value="Mobile Money"></Option>
                    <Option key="espece" value="Espèces"></Option>
                    <Option key="virement" value="Virement bancaire"></Option>
                  </Select>
                </Col>
              </Row>
            </Col>
          </Row> */}

          <Row gutter={[16, 8]}>
            {/* Ligne 1 */}
            <Col span={8}>
              <Row align="middle" gutter={8} wrap={false}>
                <Col flex="38%" style={lbl}>Coef. chargé</Col>
                <Col flex="auto">
                  <InputNumber size="small" min={0} step={100} style={ctl}
                    value={currentTrajet.coefficient_charge} onChange={set("coefficient_charge")} />
                </Col>
              </Row>
            </Col>
            <Col span={8}>
              <Row align="middle" gutter={8} wrap={false}>
                <Col flex="38%" style={lbl}>Coef. vide</Col>
                <Col flex="auto">
                  <InputNumber size="small" min={0} step={100} style={ctl}
                    value={currentTrajet.coefficient_vide} onChange={set("coefficient_vide")} />
                </Col>
              </Row>
            </Col>
            <Col span={8}>
              <Row align="middle" gutter={8} wrap={false}>
                <Col flex="38%" style={lbl}>Prix gasoil</Col>
                <Col flex="auto">
                  <InputNumber size="small" min={0} step={100} style={ctl} addonAfter="Ar/L"
                    value={currentTrajet.prix_gasoil} onChange={set("prix_gasoil")}
                    formatter={fmt} parser={parse} />
                </Col>
              </Row>
            </Col>

            {/* Ligne 2 */}
            <Col span={8}>
              <Row align="middle" gutter={8} wrap={false}>
                <Col flex="38%" style={lbl}>Aller</Col>
                <Col flex="auto">
                  <Radio.Group size="small" value={currentTrajet.status_aller}
                    onChange={(e) => handleStatusChange("aller", e.target.value)}>
                    <Radio value={1} style={{ fontSize: 12 }}>Chargé</Radio>
                    <Radio value={0} style={{ fontSize: 12 }}>Vide</Radio>
                  </Radio.Group>
                </Col>
              </Row>
            </Col>
            <Col span={8}>
              <Row align="middle" gutter={8} wrap={false}>
                <Col flex="38%" style={lbl}>Retour</Col>
                <Col flex="auto">
                  <Radio.Group size="small" value={currentTrajet.status_retour}
                    onChange={(e) => handleStatusChange("retour", e.target.value)}>
                    <Radio value={1} style={{ fontSize: 12 }}>Chargé</Radio>
                    <Radio value={0} style={{ fontSize: 12 }}>Vide</Radio>
                  </Radio.Group>
                </Col>
              </Row>
            </Col>
            <Col span={8}>
              <Row align="middle" gutter={8} wrap={false}>
                <Col flex="38%" style={lbl}>Carburant</Col>
                <Col flex="auto">
                  <InputNumber size="small" style={ctl} addonAfter="L" value={currentTrajet.carburant} />
                </Col>
              </Row>
            </Col>

            {/* Ligne 3 */}
            <Col span={8}>
              <Row align="middle" gutter={8} wrap={false}>
                <Col flex="38%" style={lbl}>Total gasoil</Col>
                <Col flex="auto">
                  <InputNumber size="small" style={ctl} addonAfter="Ar"
                    value={currentTrajet.total_gasoil} formatter={fmt} parser={parse} />
                </Col>
              </Row>
            </Col>
            <Col span={8}>
              <Row align="middle" gutter={8} wrap={false}>
                <Col flex="38%" style={lbl}>Dépenses & frais</Col>
                <Col flex="auto">
                  <InputNumber size="small" min={0} style={ctl} addonAfter="Ar"
                    value={currentTrajet.total_frais} onChange={set("total_frais")}
                    formatter={fmt} parser={parse} />
                </Col>
              </Row>
            </Col>
            <Col span={8}>
              <Row align="middle" gutter={8} wrap={false}>
                <Col flex="38%" style={lbl}>Total brut</Col>
                <Col flex="auto">
                  <InputNumber size="small" min={0} style={ctl} addonAfter="Ar"
                    value={currentTrajet.total_brute} onChange={set("total_brute")}
                    formatter={fmt} parser={parse} />
                </Col>
              </Row>
            </Col>

            {/* Ligne 4 */}
            <Col span={8}>
              <Row align="middle" gutter={8} wrap={false}>
                <Col flex="38%" style={lbl}>TVA</Col>
                <Col flex="auto">
                  <InputNumber size="small" min={0} max={100} style={ctl} addonAfter="%"
                    value={currentTrajet.tva} onChange={set("tva")} />
                </Col>
              </Row>
            </Col>
            <Col span={8}>
              <Row align="middle" gutter={8} wrap={false}>
                <Col flex="38%" style={lbl}>Bénéfice</Col>
                <Col flex="auto">
                  <InputNumber size="small" min={0} style={ctl} addonAfter="Ar"
                    value={currentTrajet.total_benefice} onChange={set("total_benefice")}
                    formatter={fmt} parser={parse} />
                </Col>
              </Row>
            </Col>
            <Col span={8}>
              <Row align="middle" gutter={8} wrap={false}>
                <Col flex="38%" style={lbl}>Acompte</Col>
                <Col flex="auto">
                  <InputNumber size="small" min={0} max={100} style={ctl} addonAfter="%"
                    value={currentTrajet.acompte} onChange={set("acompte")} />
                </Col>
              </Row>
            </Col>

            {/* Ligne 5 */}
            <Col span={8}>
              <Row align="middle" gutter={8} wrap={false}>
                <Col flex="38%" style={lbl}>Type cotation</Col>
                <Col flex="auto">
                  <Select showSearch optionFilterProp="children" size="small" style={ctl}
                    value={currentTrajet.cotation_type} onChange={set("cotation_type")}>
                    <Option key="poids" value="poids">Poids</Option>
                    <Option key="distance" value="distance">Distance</Option>
                  </Select>
                </Col>
              </Row>
            </Col>
            <Col span={8}>
              <Row align="middle" gutter={8} wrap={false}>
                <Col flex="38%" style={lbl}>Cotation</Col>
                <Col flex="auto">
                  <InputNumber size="small" min={0} style={ctl} addonAfter="Ar"
                    value={currentTrajet.cotation} onChange={set("cotation")}
                    formatter={fmt} parser={parse} />
                </Col>
              </Row>
            </Col>
            <Col span={8}>
              <Row align="middle" gutter={8} wrap={false}>
                <Col flex="38%" style={lbl}>Paiement</Col>
                <Col flex="auto">
                  <Select showSearch optionFilterProp="children" size="small" style={ctl}
                    value={currentTrajet.paiement} onChange={set("paiement")}>
                    <Option key="cheque" value="cheque">Chèque</Option>
                    <Option key="mobile_money" value="Mobile Money">Mobile Money</Option>
                    <Option key="espece" value="Espèces">Espèces</Option>
                    <Option key="virement" value="Virement bancaire">Virement bancaire</Option>
                  </Select>
                </Col>
              </Row>
            </Col>

            {/* Slider cotation pleine largeur */}
            <Col span={24}>
              <Row align="middle" gutter={8} wrap={false}>
                <Col flex="12.7%" style={lbl}>Ajuster cotation</Col>
                <Col flex="auto">
                  <Slider min={0} max={9000} style={{ margin: "0 8px" }}
                    value={currentTrajet.cotation} onChange={set("cotation")} />
                </Col>
              </Row>
            </Col>

            <Col span={24}>
              <span style={{ fontSize: 11, color: "rgba(0,0,0,0.45)" }}>
                (*) Le coefficient de distance utilisé est {currentTrajet.coefficient_distance}
              </span>
            </Col>
          </Row>
          {currentTrajet.cotation_type === "poids" && (
            <Row gutter={16}>
              <Col span={24}>
                <div
                  style={{
                    background: "linear-gradient(135deg, #f6ffed 0%, #e6f4ff 100%)",
                    border: "1px solid #b7eb8f",
                    borderRadius: 16,
                    padding: "18px 24px",
                    display: "flex",
                    flexDirection: "column",
                    gap: 14,
                    boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
                  }}
                >
                  {/* Ligne principale : prix à gauche, calcul à droite */}
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      flexWrap: "wrap",
                      gap: 16,
                    }}
                  >
                    {/* Prix réel par kg */}
                    <div style={{ display: "flex", flexDirection: "column", gap: 2 }}>
                      <Text type="secondary" style={{ fontSize: 13 }}>
                        Prix réel par kg
                      </Text>
                      <div style={{ display: "flex", alignItems: "baseline", gap: 8 }}>
                        <Title level={2} style={{ margin: 0, color: "#389e0d", lineHeight: 1.2 }}>
                          {prixReelKg.toLocaleString("fr-FR")}
                        </Title>
                        <Text strong style={{ fontSize: 16, color: "#389e0d" }}>
                          Ar/kg
                        </Text>
                      </div>
                    </div>
                    {/* Détail du calcul */}
                    <div style={{ display: "flex", alignItems: "center", gap: 10, flexWrap: "wrap" }}>
                      <Tag
                        color="blue"
                        style={{ fontSize: 14, margin: 0, height: 30, lineHeight: "28px", padding: "0 12px" }}
                      >
                        {(currentTrajet.cotation || 0).toLocaleString("fr-FR")} Ar/kg
                      </Tag>
                      <Text strong style={{ fontSize: 16, lineHeight: "30px" }}>×</Text>
                      <Tooltip title="Distance / distance de référence">
                        <Tag
                          color="orange"
                          style={{ fontSize: 14, margin: 0, height: 30, lineHeight: "28px", padding: "0 12px" }}
                        >
                          coef. distance {currentTrajet.coefficient_distance}
                        </Tag>
                      </Tooltip>
                      <Text strong style={{ fontSize: 16, lineHeight: "30px" }}>=</Text>
                      <Tag
                        color="green"
                        style={{ fontSize: 14, margin: 0, height: 30, lineHeight: "28px", padding: "0 12px" }}
                      >
                        {prixReelKg.toLocaleString("fr-FR")} Ar/kg
                      </Tag>
                    </div>
                  </div>
                  {/* Total HT / TVA / TTC */}
                  <div
                    style={{
                      borderTop: "1px dashed #b7eb8f",
                      paddingTop: 12,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      flexWrap: "wrap",
                      gap: 16,
                    }}
                  >
                    <div style={{ display: "flex", flexDirection: "column", gap: 2 }}>
                      <Text type="secondary" style={{ fontSize: 13 }}>Total HT</Text>
                      <Text strong style={{ fontSize: 16 }}>
                        {totalHT.toLocaleString("fr-FR")} Ar
                      </Text>
                    </div>

                    <Text strong style={{ fontSize: 16 }}>+</Text>

                    <div style={{ display: "flex", flexDirection: "column", gap: 2 }}>
                      <Text type="secondary" style={{ fontSize: 13 }}>TVA ({currentTrajet.tva || 0} %)</Text>
                      <Text strong style={{ fontSize: 16 }}>
                        {montantTVA.toLocaleString("fr-FR")} Ar
                      </Text>
                    </div>

                    <Text strong style={{ fontSize: 16 }}>=</Text>

                    <div style={{ display: "flex", flexDirection: "column", gap: 2 }}>
                      <Text type="secondary" style={{ fontSize: 13 }}>Total TTC</Text>
                      <Title level={3} style={{ margin: 0, color: "#389e0d", lineHeight: 1.2 }}>
                        {totalTTC.toLocaleString("fr-FR")} Ar
                      </Title>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          )}

        </div>
      )}

      <div style={{ marginTop: 30, textAlign: "right" }}>
        {currentStep > 0 && (
          <Button
            onClick={prev}
            style={{
              marginRight: 8,
              backgroundColor: "#6c757d",
              borderColor: "#6c757d",
              color: "#fff",
            }}
          >
            Précédent
          </Button>
        )}


        {currentStep < 3 &&
          !(currentStep === 1 && currentTrajet.type_devis === "benne") && (
            <Button type="primary" onClick={next}>
              Suivant
            </Button>
          )}


        {currentStep === 3 && hasPermission(getPermissionsFromToken(), "COTATION_GENERATE_DEVIS") && (
          <Button
            loading={isloading}
            type="primary"
            style={{
              backgroundColor: "#198754",
              borderColor: "#198754",
              color: "#fff",
            }}
            onClick={() => handleGenerateDevis()}
          >
            Generer Devis
          </Button>
        )}

        {currentStep === 1 && currentTrajet.type_devis === 'benne' && hasPermission(getPermissionsFromToken(), "COTATION_GENERATE_DEVIS") && (
          <Button
            loading={isloading}
            type="primary"
            style={{
              backgroundColor: "#198754",
              borderColor: "#198754",
              color: "#fff",
            }}
            onClick={() => handleGenerateBennes()}
          >
            Generer benne
          </Button>
        )}

      </div>
      <Modal
        title="Confirmation de la limite de paiement"
        open={modalLimitePaiement}
        onCancel={() => setModalLimitePaiement(false)}
        onOk={() => {
          if (
            currentTrajet.limite_paiement === null ||
            currentTrajet.limite_paiement === undefined ||
            currentTrajet.limite_paiement < 0
          ) {
            message.warning("Veuillez saisir une limite de paiement valide.");
            return;
          }

          setModalLimitePaiement(false);
          handleConfirmGenerateDevis();
        }}
        okText="Confirmer et générer"
        cancelText="Annuler"
        confirmLoading={isloading}
      >
        <p>Combien de jours accordez-vous au client pour le paiement ?</p>

        <InputNumber
          min={0}
          precision={0}
          style={{ width: "100%" }}
          placeholder="Nombre de jours"
          addonAfter="jours"
          value={currentTrajet.limite_paiement}
          onChange={(value) =>
            setcurrentTrajet((prev) => ({
              ...prev,
              limite_paiement: value,
            }))
          }
        />
      </Modal>

      {
        showToast && <Notification message={notif.message} status={notif.info} />
      }
    </div>
  );
};

export default Dotations;